module.exports = __webpack_public_path__ + "static/media/30gb.8fb0daaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/30gb.png
// module id = 134
// module chunks = 0